import React from 'react';
import { motion } from 'framer-motion';
import { Shield, AlertCircle } from 'lucide-react';

const Terms: React.FC = () => {
  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: `By accessing and using Career Guidance+ ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.`
    },
    {
      title: '2. Description of Service',
      content: `Career Guidance+ provides career guidance, educational resources, and mentorship services. We reserve the right to modify, suspend, or discontinue any aspect of the Service at any time.`
    },
    {
      title: '3. User Accounts',
      content: `You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You must immediately notify us of any unauthorized use of your account.`
    },
    {
      title: '4. User Conduct',
      content: `You agree not to use the Service for any unlawful purpose or in any way that could damage, disable, overburden, or impair the Service.`
    },
    {
      title: '5. Content',
      content: `All content provided on the Service is for informational purposes only. We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information.`
    },
    {
      title: '6. Privacy',
      content: `Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your personal information.`
    },
    {
      title: '7. Intellectual Property',
      content: `All content, features, and functionality of the Service are owned by Career Guidance+ and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.`
    },
    {
      title: '8. Limitation of Liability',
      content: `Career Guidance+ shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service.`
    },
    {
      title: '9. Changes to Terms',
      content: `We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service.`
    },
    {
      title: '10. Governing Law',
      content: `These terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.`
    }
  ];

  return (
    <main className="bg-gray-50 min-h-screen py-12">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-12">
            <Shield className="h-16 w-16 text-primary-600 mx-auto mb-6" />
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
            <p className="text-xl text-gray-600">
              Last updated: February 15, 2025
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8">
              <div className="flex">
                <AlertCircle className="h-6 w-6 text-yellow-400 mr-3" />
                <p className="text-sm text-yellow-700">
                  Please read these terms carefully before using Career Guidance+. By using our service, you agree to be bound by these terms.
                </p>
              </div>
            </div>

            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    {section.title}
                  </h2>
                  <p className="text-gray-600 leading-relaxed">
                    {section.content}
                  </p>
                </motion.div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-gray-600 text-sm">
                If you have any questions about these Terms of Service, please contact us at{' '}
                <a href="mailto:legal@careerguidance.com" className="text-primary-600 hover:text-primary-700">
                  legal@careerguidance.com
                </a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default Terms;